module.exports = __webpack_public_path__ + "static/img/Home Page.d2f27dae.svg";